import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title_text" }, "小米-当日签到奖励")
], -1)

import { get } from '@/utils/request'
  import { ElButton } from 'element-plus'
  import zhLocale from 'element-plus/es/locale/lang/zh-cn'
  import { ref } from 'vue'

  type DayMap = {
    [key: string]: string;
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'XiaomiSign',
  setup(__props) {


  const locale = ref(zhLocale)
  const pageData = ref({
    list: null,
    total: 0,
    currentPage: 1,
    pageSize: 20
  })
  const search = ref({
    day: 'tomrrow'
  })
  const now = new Date()
  const today = now.getTime()
  console.log(today)
  const yesterday = new Date().setDate(now.getDate() - 1)
  const tomorrow = new Date().setDate(now.getDate() + 1)
  console.log(tomorrow)
  console.log(yesterday)


  const dayMap:DayMap = {
    yesteday: timestampToTime(yesterday),
    today: timestampToTime(today),
    tomrrow: timestampToTime(tomorrow)
  }
  async function dayChange (day: string) {
    search.value.day = day
    const searchDay = dayMap[day]
    getSignList(searchDay, pageData.value.currentPage, pageData.value.pageSize)
  }

  async function handlePageChange (newPage: number) {
    pageData.value.currentPage = newPage
    const searchDay = dayMap[search.value.day]
    getSignList(searchDay, newPage, pageData.value.pageSize)
  }
  async function getSignList (searchDay:string, pageNumber: number, pageRow: number) {
    const res = await get(`/kafuFour/signReward/page?pageNum=${pageNumber}&pageRow=${pageRow}&signDay=${searchDay}`) // &signDay=2023-11-30
    pageData.value.list = res.list
    pageData.value.total = res.total
  }

  function timestampToTime (timstap:number) {
    const date = new Date(timstap)
    console.log(date)
    const Y = date.getFullYear() + '-'
    console.log(Y)
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
    // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    // const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D
  }

  getSignList('', pageData.value.currentPage, pageData.value.pageSize)
  
return (_ctx: any,_cache: any) => {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_ElConfigProvider = _resolveComponent("ElConfigProvider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_row, { class: "mb-4" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElButton), {
          type: search.value.day=='yesteday'?'primary':'Default',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dayChange('yesteday')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("昨天")
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_unref(ElButton), {
          type: search.value.day=='today'?'primary':'Default',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (dayChange('today')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("今天")
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_unref(ElButton), {
          type: search.value.day=='tomrrow'?'primary':'Default',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (dayChange('tomrrow')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("明天")
          ]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    }),
    _createVNode(_component_ElConfigProvider, { locale: locale.value }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: pageData.value.list,
          border: "true",
          height: "800px",
          class: "el-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "tradeId",
              label: "序号",
              width: "70px"
            }, {
              default: _withCtx((scop) => [
                _createTextVNode(_toDisplayString(scop.$index+1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "rewardType",
              label: "奖励类型",
              width: "100px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "rewardName",
              label: "奖励内容",
              width: "120px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "rewardQuantity",
              label: "奖励份额",
              width: "100px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "url",
              label: "活动地址"
            }),
            _createVNode(_component_el_table_column, {
              prop: "days",
              label: "签到天数",
              width: "100px"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          total: pageData.value.total,
          "current-page": pageData.value.currentPage,
          "page-size": pageData.value.pageSize,
          layout: "total,prev, pager,",
          onCurrentChange: _cache[3] || (_cache[3] = ($event: any) => (handlePageChange($event))),
          background: "--el-color-primary",
          class: "pageEl"
        }, null, 8, ["total", "current-page", "page-size"])
      ]),
      _: 1
    }, 8, ["locale"])
  ], 64))
}
}

})